import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 12h-15","key":"svg-0"}],["path",{"d":"M6 9l-3 3l3 3","key":"svg-1"}],["path",{"d":"M21 9l-3 3l3 3","key":"svg-2"}]]

const IconArrowLeftTail = createReactComponent('outline', 'arrow-left-tail', 'ArrowLeftTail', __iconNode);

export default IconArrowLeftTail;